// extracted by mini-css-extract-plugin
module.exports = {"label":"LogsComponent_label__1gtx9","maxHeight200px":"LogsComponent_maxHeight200px__20GFa","maxWidth9Rem":"LogsComponent_maxWidth9Rem__2jJe7"};